"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./Table.css");
var Tr_1 = require("./components/Tr");
var Thead_1 = require("./components/Thead");
var RowGroup_1 = require("./components/RowGroup");
var lodash_1 = require("lodash");
var Table = /** @class */ (function (_super) {
    __extends(Table, _super);
    function Table(props) {
        var _this = _super.call(this, props) || this;
        _this.renderChildren = _this.renderChildren.bind(_this);
        _this.onSort = _this.onSort.bind(_this);
        return _this;
    }
    Table.prototype.componentDidMount = function () {
        var _this = this;
        if (!(this.props.options && this.props.options.ignoreDynamicThHeight)) {
            this.getThHeight();
            window.addEventListener('resize', lodash_1.throttle(function () { _this.getThHeight(); }, 200));
        }
    };
    Table.prototype.componentWillUnMount = function () {
        if (!(this.props.options && this.props.options.ignoreDynamicThHeight)) {
            window.removeEventListener('resize', this.getThHeight);
        }
    };
    Table.prototype.getThHeight = function () {
        var e_1, _a;
        if (!(this.props.options.setWidth)) {
            var tdWidths = [];
            if (this.ref.querySelectorAll('thead th')) {
                var THs = Array.from(this.ref.querySelectorAll('thead th'));
                try {
                    for (var THs_1 = __values(THs), THs_1_1 = THs_1.next(); !THs_1_1.done; THs_1_1 = THs_1.next()) {
                        var th = THs_1_1.value;
                        th.setAttribute('width', "" + (th.clientWidth + 'px'));
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (THs_1_1 && !THs_1_1.done && (_a = THs_1.return)) _a.call(THs_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        }
    };
    Table.prototype.render = function () {
        var _this = this;
        var testId = this.props.testId;
        return (React.createElement("div", { className: styles.tableOverflow },
            React.createElement("table", { id: this.props.options.id, cellPadding: "0", cellSpacing: "0", className: [this.props.options.className, styles.dataTable].join(' '), "data-test-id": testId, ref: function (ref) { _this.ref = ref; } }, this.renderChildren())));
    };
    Table.prototype.onSort = function (dataType, key, sortOrder) {
        if (this.props.events && this.props.events.onSort) {
            this.props.events.onSort(dataType, key, sortOrder);
        }
    };
    Table.prototype.renderChildren = function () {
        var _this = this;
        var allowedChilds = [Thead_1.default, RowGroup_1.default, Tr_1.default];
        return React.Children.map(this.props.children, function (child) {
            if (!child) {
                return;
            }
            if (!allowedChilds.includes(child.type)) {
                // tslint:disable-next-line:no-console
                console.error(child.type + " is not allowed child of Table component");
                return null;
            }
            var bodyRowClass = child.type === Tr_1.default ? styles.bodyRow : '';
            var childProps = {
                options: __assign(__assign({}, child.props.options), { className: [child.props.options.className, bodyRowClass].join(' '), 
                    // colWidth: (this.props.options && this.props.options.colWidth ? this.props.options.colWidth : null),
                    collapsible: _this.props.options.collapsible, collapsibleKey: _this.props.options.collapsibleKey }),
            };
            if (_this.props.options) {
                if (_this.props.options.collapseFrom) {
                    childProps.options = __assign(__assign({}, childProps.options), { collapseFrom: _this.props.options.collapseFrom });
                }
                if (_this.props.options.sortable) {
                    childProps.options = __assign(__assign({}, childProps.options), { 
                        // colWidth: (this.props.options && this.props.options.colWidth ? this.props.options.colWidth : null),
                        sortKey: _this.props.options.sortKey, sortOrder: _this.props.options.sortOrder });
                    childProps.events = __assign(__assign({}, child.props.events), { onSort: _this.onSort });
                }
            }
            return React.cloneElement(child, childProps);
        });
    };
    Table.defaultProps = {
        options: {
            className: '',
        },
    };
    return Table;
}(React.Component));
exports.default = Table;
//# sourceMappingURL=Table.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Table/Table.js
// module id = 1364
// module chunks = 8